<template>
    <div class="p-5">
        <div class="mt-5 mb-5 valid-button" v-if="criteriaFamilies.length > 0 && hasCriteriaFamiliesWithNoName">
            <div class="title-valid-button">
                <v-icon color="warning">warning</v-icon>
                Questions
            </div>

            <div class="mt-3">
                Au moins une
                <span class="span-link" @click="setCurrentStep(1)">question</span>
                n'a pas d'intitulé.
            </div>
        </div>

        <div class="mt-5 mb-5 valid-button" v-if="criteriaFamilies.length > 0 && hasCriteriasWithNoName">
            <div class="title-valid-button">
                <v-icon color="warning">warning</v-icon>
                Réponses
            </div>

            <div class="mt-3">
                Au moins une
                <span class="span-link" @click="setCurrentStep(1)">réponse</span>
                n'a pas d'intitulé.
            </div>
        </div>


        <div class="mt-5 mb-5 valid-button" v-if="!hasOffersEnabled">
            <div class="title-valid-button">
                <v-icon color="warning">warning</v-icon>
                Offres
            </div>

            <div class="mt-3">
                Au moins une <span class="span-link" @click="setCurrentStep(2)">offre</span> doit-être active.
            </div>
        </div>

        <div class="mt-5 mb-5 valid-button" v-if="!hasPaymentOptionsEnabled">
            <div class="title-valid-button">
                <v-icon color="warning">warning</v-icon>
                Moyens de paiement
            </div>

            <div class="mt-3">
                Au moins un
                <span class="span-link" @click="setCurrentStep(5)">moyen de paiement</span>
                doit-être actif.
            </div>
        </div>

        <div class="mt-5 mb-5 valid-button" v-if="!hasThanksEmailSet">
            <div class="title-valid-button">
                <v-icon color="warning">warning</v-icon>
                Email de remerciement
            </div>

            <div class="mt-3">
                <span class="span-link" @click="redirectToEmailConfig()">L' email de remerciement</span>
                n'est pas entièrement configuré.
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
export default {
    name: "CadhConfigCheck",
    data() {
        return {

        }
    },
    methods: {
        ...mapMutations("cadhConfig", ['setCurrentStep', "setParameterCurrentStep"]),
        redirectToEmailConfig() {
            this.setCurrentStep(6)
            this.setParameterCurrentStep(3)
        }
    },
    computed: {
        ...mapState("cadhConfig", ['hasOffersEnabled', 'hasPaymentOptionsEnabled', "criteriaFamilies",
            "hasCriteriaFamiliesWithNoName", "hasCriteriasWithNoName", "hasThanksEmailSet"])
    }
}
</script>